// extracted by mini-css-extract-plugin
export var link = "read-more-module--link--3UZLM";